// extracted by mini-css-extract-plugin
module.exports = {"crossedPrice":"_1PAPpL"};